<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>From</mat-label>
            <input
                type="email"
                required
                name="replyTo"
                [(ngModel)]="applicantMessage.replyTo"
                #replyTo="ngModel"
                matInput
            />
            <mat-error *ngIf="replyTo.invalid">{{ 'Please provide a valid email' }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>Job Posting</mat-label>
            <mat-select
                required
                name="jobPostingId"
                [(ngModel)]="applicantMessage.jobPostingId"
                (selectionChange)="onJobPostingChange()"
            >
                <mat-option *ngFor="let jobPosting of jobPostings" [value]="jobPosting.id">{{
                    jobPosting.title
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>Template</mat-label>
            <mat-select name="templateId" [(ngModel)]="templateId" (selectionChange)="onTemplateIdChange()">
                <mat-option value="free-form">Free Form</mat-option>
                <mat-option *ngFor="let template of applicantMessageTemplates" [value]="template.id">{{
                    template.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>Funnel Stage</mat-label>
            <mat-select required name="jobFunnelId" #jobFunnelSelect [(ngModel)]="applicantMessage.jobFunnelId">
                <mat-option *ngFor="let jobFunnel of selectedJobPosting?.jobFunnels" [value]="jobFunnel.id">{{
                    jobFunnel.funnelStep
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="columns-12 small-columns-12">
            <mat-label>Subject</mat-label>
            <input
                type="text"
                required
                name="subject"
                [(ngModel)]="applicantMessage.subject"
                #subject="ngModel"
                matInput
            />
            <mat-error *ngIf="subject.invalid">{{ 'Please provide a valid subject' }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label>Body</mat-label>
            <ui-rich-text
                name="body"
                required
                #body="ngModel"
                [(ngModel)]="applicantMessage.body"
                [stripNewlines]="true"
            ></ui-rich-text>
        </mat-form-field>
    </div>
</form>
